import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campaigns, Campus, Consentement, Disponibilites, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { useForms, useSalesforce, useUrlReturn } from "hooks"
import { campaigns, defaultValues, getAcademicLevels, optionsAvailabilitiesEpitech, salutations } from "services"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('EDS-DIGICLUB')
  const { url: url_contact } = useUrlReturn('EDS-CONTACT')
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...campaigns,
      lead: {
        ...defaultValues,
        PostalCode: '',
        Salutation: ''
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, watch } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campaignId = data.campaignId
    const defaultDataLead = {
      Company: lead.FirstName + ' ' + lead.LastName,
      Is_From_Web__c: true,
      LeadSource: campaignId !== 'unavailable' ? 'Atelier' : 'Demande de rendez-vous',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      const leadCreated = await salesforce.createLead(finalLead)
      if (campaignId !== 'unavailable') {
        const campaignMember = {
          CampaignId: campaignId,
          LeadId: leadCreated.Id,
          Status: 'Registered'
        }
        await salesforce.createCampaignMember(campaignMember)
        document.location.href=`${url}?campus=${campus}&campaignId=${campaignId}`
      } else {
        let description = ''

        if (data.availabilities.type === 'Être rappelé(e) sur Skype') {
          description = 'ID Skype : ' + data.availabilities.skypeId + '\n\n'
        }
        description += data.availabilities.dates.join(', ')

      const subject = data.availabilities.type
        const task = {
          ActivityDate: new Date(),
          Description: description,
          OwnerId: leadCreated.OwnerId,
          Subject: subject,
          WhoId: leadCreated.Id
        }

        await salesforce.createTask(task)
        document.location.href=`${url}?campus=${campus}`
      }
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const campus = watch('lead.Campus__c')
  // useEffect
  useSalesforce('EPITECH DIGITAL', true)

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel options={getAcademicLevels('Epitech Digital')} section={false} specialites={false} />
        <Grid item xs={12}>
          <InputText control={control} label="Code postal" name="lead.PostalCode" required />
        </Grid>
        <Campus label="Ville choisie pour participer à l'atelier d'immersion" />
        <Campaigns eda={true} school="Epitech Digital" text="à l'atelier d'immersion" type="Atelier" />
        <Disponibilites eda={true} availabilities={optionsAvailabilitiesEpitech} text="pour nos ateliers d'immersion" />
        <Consentement form="Atelier" school="Epitech Digital" />
        <Submit onSubmit={onSubmit} />
        <RequiredFields />
      </Grid>
    </FormProvider>
  )
}

export default Form
